import { createAsyncThunk } from "@reduxjs/toolkit";

import magnifiAPI from "../../services/api/magnifi";

export const getServerDetails = createAsyncThunk("server/getServerDetails", async (payload) => {
  try {
    const response = await magnifiAPI.getServerDetails(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const createServer = createAsyncThunk("server/createServer", async (payload) => {
  try {
    const response = await magnifiAPI.createServer(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const deleteServer = createAsyncThunk("server/delete-server", async (payload) => {
  try {
    const response = await magnifiAPI.deleteServer(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});
